import { c as _c } from "react/compiler-runtime";
import styles from './ReferralPage.module.css';
export function ReferralLoadingSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.loadingCard}><div className={`${styles.skeletonHeading} ${styles.skeletonBar}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar} ${styles.skeletonW80}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar} ${styles.skeletonW90}`} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className={styles.loadingContainer} aria-label="Loading referral information" aria-busy="true">{t0}<div className={styles.loadingCard}><div className={`${styles.skeletonHeading} ${styles.skeletonBar}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar} ${styles.skeletonW85}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar} ${styles.skeletonW75}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar}`} /><div className={`${styles.skeletonContent} ${styles.skeletonBar} ${styles.skeletonW80}`} /></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}